import styled from "styled-components";
import LinkButton from "components/LinkButton";

// Banner is kept solely for CurrentParcelGuide's guide banner — demo surfaces
// render inside Frame/FrameHeader via DemoFrame (which reuses BannerTitle and
// BannerSubtitle for its text).
export const Banner = styled.div`
  margin: 15px 0 14px;
  padding: 16px 20px;
  text-align: center;
  background: ${({ theme }) => theme.infoHighlightBg};
  border-radius: 2px;

  ${({ theme }) => theme.xs`
    text-align: left;
  `}
`;

export const BannerTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.accentText};
`;

export const BannerSubtitle = styled.div`
  margin-top: 6px;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.black50};
`;

export const FadeWrapper = styled.div`
  opacity: 0.85;
`;

export const Frame = styled.div`
  margin: 15px 0 14px;
  padding: 0 12px 12px;
  background: ${({ theme }) => theme.infoHighlightBg};
  border: 1px dashed ${({ theme }) => theme.primary05};
  border-radius: 2px;
`;

export const FrameHeader = styled.div`
  padding: 16px 8px 14px;
  text-align: center;

  ${({ theme }) => theme.xs`
    text-align: left;
  `}
`;

export const HideButton = styled(LinkButton)`
  margin-top: 10px;
`;
